import { render, staticRenderFns } from "./TATReports.vue?vue&type=template&id=7436929c&scoped=true"
import script from "./TATReports.vue?vue&type=script&lang=js"
export * from "./TATReports.vue?vue&type=script&lang=js"
import style0 from "./TATReports.vue?vue&type=style&index=0&id=7436929c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7436929c",
  null
  
)

export default component.exports